import React from "react";
import { ASSETS } from "@/lib/brand";

export const WhoIsPaula = () => {
  return (
    <section
      id="paula"
      data-testid="paula-section"
      className="relative py-24 sm:py-32 bg-white border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-stretch">
          {/* Big portrait card */}
          <div className="lg:col-span-5">
            <div className="relative h-full rounded-3xl bg-paula-yellow-soft border border-paula-yellow/30 p-8 flex flex-col">
              <div className="text-xs font-semibold uppercase tracking-[0.2em] text-paula-red">
                Wer ist Paula?
              </div>
              <div className="mt-6 flex-1 grid place-items-center">
                <img
                  src={ASSETS.paulaCharacter}
                  alt="Pinguin Paula"
                  className="w-full max-w-[300px] paula-bob"
                  data-testid="paula-portrait"
                />
              </div>
              <div className="mt-6 grid grid-cols-3 gap-2 text-center">
                <div className="rounded-xl bg-white border border-slate-200 py-3">
                  <div className="text-[10px] uppercase tracking-widest text-paula-muted">Beruf</div>
                  <div className="font-display font-semibold text-paula-ink text-sm">Sanitäterin</div>
                </div>
                <div className="rounded-xl bg-white border border-slate-200 py-3">
                  <div className="text-[10px] uppercase tracking-widest text-paula-muted">Notruf</div>
                  <div className="font-display font-semibold text-paula-red text-sm">112</div>
                </div>
                <div className="rounded-xl bg-white border border-slate-200 py-3">
                  <div className="text-[10px] uppercase tracking-widest text-paula-muted">Motto</div>
                  <div className="font-display font-semibold text-paula-blue text-sm">Bleib cool</div>
                </div>
              </div>
            </div>
          </div>

          {/* Story */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <h2 className="font-display font-bold text-4xl sm:text-5xl text-paula-ink leading-[1.05] tracking-tight">
              Eine kleine Pinguindame mit{" "}
              <span className="text-paula-red">ganz viel Herz</span>.
            </h2>
            <div className="mt-8 space-y-5 text-lg text-paula-ink/85 leading-relaxed">
              <p>
                Paula ist Rettungssanitäterin — und ein Pinguin. Mit roter
                Kappe, Erste-Hilfe-Tasche und einem Lächeln, das selbst die
                tapfersten Tränen trocknet.
              </p>
              <p>
                In ihrem Ausmalbuch begleitet sie Kinder durch echte Notfälle —
                in kindgerechter Sprache, mit Bildern zum Selbermalen, mit der
                HELD-Regel zum Mitmachen. Aus „Ich kann das nicht" wird{" "}
                <span className="font-semibold text-paula-ink">
                  „Ich helfe!"
                </span>
              </p>
              <p>
                Paula ist Buchheldin, Plüschtier, Lernbegleiterin — und vor
                allem eine Freundin. Eine, die da ist, wenn es wirklich zählt.
              </p>
            </div>

            {/* Quote chip */}
            <blockquote className="mt-10 relative pl-6 border-l-4 border-paula-yellow">
              <p className="font-display italic text-xl text-paula-ink leading-snug">
                „Hallo, ich bin Rettungssanitäterin Paula und ich möchte Dir
                zeigen, wie Du ganz einfach cool bleibst."
              </p>
              <footer className="mt-3 text-sm font-semibold text-paula-muted uppercase tracking-widest">
                — Paula, Seite 4
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoIsPaula;
